import {Component, Input, OnInit} from '@angular/core';
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {UserDataService} from "@core/services/user-data/user-data.service";
import {TClientInfo} from "@core/models/user-data.model";
import {NavigationService} from "@core/services/navigation/navigation.service";
import {IonModal} from "@ionic/angular";

@UntilDestroy()
@Component({
    selector: 'app-mortgage-insurance-request-page-request-success',
    templateUrl: './mortgage-insurance-request-success.component.html',
    styleUrls: ['./mortgage-insurance-request-success.component.scss'],
    standalone: false
})
export class MortgageInsuranceRequestSuccessComponent implements OnInit {
  @Input() modal: IonModal;
  @Input() staticHeight: boolean;

  clientInfo: TClientInfo;

  constructor(private userDataService: UserDataService, private navigationService: NavigationService) { }

  ngOnInit() {
    this.userDataService.getClientInfo().pipe(untilDestroyed(this))
      .subscribe(info => {
      this.clientInfo = info;
    });
  }

  handleRefresh(event?: any): void {
    event?.target.complete();
  }

  close(): void {
    this.modal.dismiss();
    void this.navigationService.setRoot('/main');
  }

}
